import Header from "../../components/Header";
import ContentWrapper from "../../components/ContentWrapper";
import BoxSigns from "./_components/BoxSigns";

const Signs = () => (
  <>
    <div className="px-[10px] pt-[5px]">
      <Header />
    </div>
    <ContentWrapper>
      <BoxSigns />
    </ContentWrapper>
  </>
);

export default Signs;
